import {PlayerReduxState} from "../types";
import getCurrentAction from "./getCurrentAction";
import {ChallengeMode} from "../../../schema";

export enum ChoiceUserInputDisplayMode {
  ALL_WITH_HINT,
  ALL,
  ONLY_VALID
}

export default function getCurrentActionChoiceMode(state: PlayerReduxState): ChoiceUserInputDisplayMode | undefined {
  const action = getCurrentAction(state);

  if (action?.__typename !== "ChoiceUserInputAction") {
    return undefined;
  }

  switch (state.challenge.mode) {
    case ChallengeMode.COMPETENCE_TEST:
    case ChallengeMode.CHOICE_BASED_STUDY:
    case ChallengeMode.CHOICES_WITH_CUSTOM_SCORES:
    case ChallengeMode.CUSTOM_PARAMETERS_TEST:
    case ChallengeMode.RPG_MODE:
      switch (state.level) {
        case 1:
          return ChoiceUserInputDisplayMode.ALL;
        case 2:
        case 3:
          return ChoiceUserInputDisplayMode.ONLY_VALID;
        default:
          console.warn("getCurrentActionChoiceMode: wrong level");
          return ChoiceUserInputDisplayMode.ALL;
      }

    default:
      console.warn("getCurrentActionChoiceMode: unsupported challenge mode");
      return ChoiceUserInputDisplayMode.ALL;
  }
}
